import { ref, reactive, onMounted, nextTick, watch } from 'vue'
import useAppStore from '@/h5/stores/app'

/** 轮播组件-开放事件 */
export const SWIPER_EVENTS = [
  {
    name: 'slidePrev', // 事件名
    label: '切换上一页' // 事件描述
  },
  {
    name: 'slideNext',
    label: '切换下一页'
  },
  {
    name: 'slideTo',
    label: '跳转指定页',
    params: [
      {
        label: '目标索引',
        value: 'index'
      }
    ]
  }
]

/** 轮播组件-开放数据源 */
export const SWIPER_DATA_SOURCE = [
  {
    label: '轮播总数',
    keys: 'swiperTotal',
    description: '轮播图的总数量'
  },
  {
    label: '当前轮播索引',
    keys: 'swiperIndex',
    description: '当前显示的轮播图索引，从0开始'
  }
]

/**
 * 轮播通用hook
 * @returns
 */
export const useSwiper = (props) => {
  const swiperRef = ref(null)
  const swiperInstance = ref(null)
  const refreshIndex = ref(0)
  const slideItems = ref(props.items)
  const appStore = useAppStore ? useAppStore() : null

  // 组件属性
  const state = reactive({
    // 语言
    language: 'en',
    // 组件uuid
    uuid: '',
    dataSource: { swiperIndex: 0, swiperTotal: 0 },
  })

  onMounted(() => {
    nextTick(() => {
      if (swiperRef.value) {
        state.language = swiperRef.value.getAttribute('language') || 'en'
        state.uuid = swiperRef.value.getAttribute('id') || ''
      }
    })
  })

  watch([
    () => props.direction,
    () => props.rtl,
    () => props.effect,
    () => props.showPagination,
    () => props.showNavigation,
    () => props.paginationType,
    () => props.autoplay,
    () => props.delay,
    () => props.stopOnLastSlide,
    () => props.loop,
    () => props.mousewheel,
    () => props.a11y,
    () => props.paginationPosition
  ], () => {
    refreshIndex.value += 1
  })

  watch(() => props.activeIndex, (newIndex) => {
    if (swiperInstance.value) {
      swiperInstance.value.slideTo(newIndex)
    }
  })

  watch(() => props.items, (newItems, oldItems) => {
    if (newItems !== oldItems && newItems.length > 0) {
      slideItems.value = [...newItems]
      nextTick(() => {
        refreshIndex.value += 1
      })
    }
    state.dataSource.swiperTotal = [...newItems].length || 0
    appStore && appStore.setPageDataSource(state.uuid, state.dataSource || null)
  }, { immediate: true, deep: true })

  const onSwiper = (swiper) => {
    swiperInstance.value = swiper
  }

  const onSlideChange = () => { 
    if (swiperInstance.value) {
      setTimeout(() => {
        state.dataSource.swiperIndex = swiperInstance.value.realIndex || 0 // 使用 realIndex 代替 activeIndex
        appStore && appStore.setPageDataSource(state.uuid, state.dataSource || null)
      }, 0)
    }
  }

    // 切换到上一页
  const slidePrev = () => {
    if (swiperInstance.value) {
      swiperInstance.value.slidePrev()
    }
  }

  // 切换到下一页
  const slideNext = () => {
    if (swiperInstance.value) {
      swiperInstance.value.slideNext()
    }
  }

  // 跳转到指定页
  const slideTo = (params) => {
    const index = Number(params.index)
    if (swiperInstance.value && index >= 0) {
      swiperInstance.value.slideTo(index)
    }
  }
  

  return {
    swiperRef,
    swiperInstance,
    refreshIndex,
    slideItems,
    onSwiper,
    onSlideChange,
    slidePrev,
    slideNext,
    slideTo
  }
}
